module.exports = __webpack_public_path__ + "img/doc-and-ref-old.4bdbb9b4.svg";